export default async function getImageType(imageURL: string): Promise<string> {
    const response = await fetch(imageURL)
    const blob = await response.blob()
    return blob.type
}
